import { render, staticRenderFns } from "./Home-mobile.vue?vue&type=template&id=708a8314&scoped=true"
import script from "./Home-mobile.vue?vue&type=script&lang=js"
export * from "./Home-mobile.vue?vue&type=script&lang=js"
import style0 from "./Home-mobile.vue?vue&type=style&index=0&id=708a8314&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a8314",
  null
  
)

export default component.exports